import { render, staticRenderFns } from "./ReactionEmailOption.vue?vue&type=template&id=0cd6dec0&"
import script from "./ReactionEmailOption.vue?vue&type=script&lang=js&"
export * from "./ReactionEmailOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports